// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hover-dot[data-v-c713478a]{position:fixed;top:0;left:0;z-index:999999}.dot[data-v-c713478a]{width:5px;height:5px;border-radius:50%;background:#000}", ""]);
// Exports
module.exports = exports;
